// extracted by mini-css-extract-plugin
module.exports = {"signupHeader":"signupHeader-TeS7z","signupHeaderTitle":"signupHeaderTitle-6dEgT","firstTextLine":"firstTextLine-yP6OV","secondTextLine":"secondTextLine-VyE1C"};